// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "283d57cd048c8c6f8d779f8b161b8c08" + ".css";
};